export default __webpack_public_path__ + "static/media/Q7_3_resized.99852099.jpg";